<div
  class="employee-initials-requestor rounded-circle in-the-middle placer-margin"
>
  <span style="margin-top: 2px;" *ngIf="!profilePicture">
    {{ firstName | initials: lastName }}
  </span>
  <span *ngIf="profilePicture">
    <img
      style="margin-top: 2px;"
      class="rounded-circle"
      width="30px"
      height="30px"
      [src]="'/api/assets/' + profilePicture.uuid + '/30'"
    />
  </span>
</div>
